import type { FrontendWidget } from '../types';
import { IconCardWidgetComponent } from './IconCardWidgetComponent';
import { IconCardWidgetComponentB } from './IconCardWidgetComponentB';
import { IconCardWidgetComponentC } from './IconCardWidgetComponentC';
import type { IconCardWidgetConfig, IconCardWidgetResolved } from './types';
import { SectionBackgroundColor } from '@/lib/section-colors';

export const iconCardWidget: FrontendWidget<
  IconCardWidgetConfig,
  IconCardWidgetResolved
> = {
  componentType: 'widgets.icon-card-widget',
  displayName: 'Icon Card Widget',
  defaultValues: {
    background: SectionBackgroundColor.White,
    columns: '1',
    cards: [],
  },
  ComponentA: IconCardWidgetComponent,
  ComponentB: IconCardWidgetComponentB,
  ComponentC: IconCardWidgetComponentC,
  resolveSync: (config) => ({
    background: config.background ?? SectionBackgroundColor.White,
    columns: parseInt(config.columns ?? '1', 10),
    items: (config.cards ?? []).map((card) => ({
      id: card.id ?? 0,
      iconDesktop: card.iconDesktop ?? '',
      iconMobile: card.iconMobile ?? '',
      title: card.title ?? '',
      body: card.body ?? '',
    })),
  }),
};
